export const EXSBWAREHOUSEITEM_CREATE_RESET = 'EXSBWAREHOUSEITEM_CREATE_RESET'
export const EXSBWAREHOUSEITEM_CREATE_SET_CREATED = 'EXSBWAREHOUSEITEM_CREATE_SET_CREATED'
export const EXSBWAREHOUSEITEM_CREATE_SET_ERROR = 'EXSBWAREHOUSEITEM_CREATE_SET_ERROR'
export const EXSBWAREHOUSEITEM_CREATE_SET_VIOLATIONS = 'EXSBWAREHOUSEITEM_CREATE_SET_VIOLATIONS'
export const EXSBWAREHOUSEITEM_CREATE_TOGGLE_LOADING = 'EXSBWAREHOUSEITEM_CREATE_TOGGLE_LOADING'
